"use strict";

angular.module("core").component("paymentDetails", {
    controllerAs: "paymentDetailsCtrl",
    templateUrl: require("./payment-details.component.html"),
    controller: function(
        $scope, $stateParams, IS_MOBILE, PaymentService, PaymentMethodsService, UserService
    ) {
        $scope.paymentService = PaymentService;
        $scope.statusNamesLocalized = PaymentService.getStatusNamesLocalized();
        $scope.methodChoicesLocalized = PaymentMethodsService.getMethodChoicesLocalized();
        $scope.isMobile = IS_MOBILE;
        $scope.payment = $scope.paymentService.get($stateParams.id);
        $scope.isVendor = null;

        UserService.isUserFetched().then(function onSuccess(user) {
            $scope.isVendor = !!user && user.vendor;
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/payment/payment-details.component.js
// module id = 645
// module chunks = 0